import React, { Component } from 'react';

import Login from './Login';
import AdmHeader from './AdmHeader';
import ListaApps from './ListaApps';

import '../css/AdmPage.css';

class AdmPage extends Component {
  constructor() {
    super();
    this.state = {
        login : false
    };
  }

  checkToken(){
    return new Promise(
      (resolve, reject) => { 
        let token= window.localStorage.getItem("AUTH-X-TOKEN");
        resolve(token);
      }
    );
  }

  handleLogin(login){
    this.setState({login})
  }

  componentWillMount() {
    this.checkToken().then(token => {
      if(token) this.setState({login: true});
    });
  }

  render() {
    if (this.state.login) {

        return (
          <div id="">
            <AdmHeader />
            <ListaApps />
          </div>  
        );


    } else {
      return (
        <div id="admPage-content">
          <Login callbackLogin={this.handleLogin.bind(this)} />
        </div>  
      );
    }

  }
}

export default AdmPage;



// WEBPACK FOOTER //
// ./src/adm/componentes/AdmPage.js